import React from 'react';
import PropTypes from 'prop-types';
import { Button, Card, CardBody, Heading, Text } from 'grommet';
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

export const AdminDashboardCard = ({ card, ...rest }) => {
    const history = useHistory();
    const { background, cta, description, descriptionColor, icon, title, onClick = () => {
        if (title === 'Competitive Data Manager') {
            history.push('/admin-manager')
        }
        if (title === 'User Feedback') {
            history.push('/admin-user-feedback')
        }
        if (title === 'Customize User Announcements') {
            history.push('/admin-announcements')
        }
    } } = card;
    return (
        <Card background={background || 'background'} fill {...rest} hoverIndicator={false}>
            <CardBody gap="small" align="start" flex="grow">
                {icon}
                <Heading margin="none" level={2}>
                    {title}
                </Heading>
                <Text color={descriptionColor}>{description}</Text>
                {typeof cta === 'string' ? <Button label={cta} secondary onClick={onClick} /> : cta}
            </CardBody>
        </Card>
    );
};

AdminDashboardCard.propTypes = {
    card: PropTypes.shape({
        background: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({})]),
        cta: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
        description: PropTypes.string,
        descriptionColor: PropTypes.string,
        icon: PropTypes.element,
        title: PropTypes.string,
    }).isRequired,
};